module.exports = __webpack_public_path__ + "static/img/newStock3.25db0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/newStock/newStock3.jpg
// module id = E0Cq
// module chunks = 1